import React, { ReactElement, forwardRef } from 'react';
import { FixedSliderRef, FixedSliderProps, FixedSlider } from './FixedSlider';
import { FreeSlider } from './FreeSlider';
import './Slider.scss';

export type SliderRef = FixedSliderRef;

export enum SliderMode {
    Fixed,
    Free,
}

export interface SliderProps extends FixedSliderProps {
    mode?: SliderMode;
}

const Slider = forwardRef<SliderRef, SliderProps>(function Slider(
    { mode = SliderMode.Fixed, children, ...props }, ref): ReactElement {
    return mode === SliderMode.Fixed
        ? <FixedSlider ref={ref} {...props}>{children}</FixedSlider>
        : <FreeSlider {...props}>{children}</FreeSlider>;
});

export default Slider;
